import "../styles/Header.css";
import bankLogo from "../assets/photos/bank-logo.png";
import { useState } from "react";
import { Link } from "react-router-dom";

function Header() {

    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <header className="main-header">

            <div className="header-left">
                <img src={bankLogo} alt="Sahyadri Bank" />

                <span className="bank-name">
                    The Sahyadri Sahakari Bank Ltd.
                </span>
            </div>

            <nav className="header-nav">
                <ul>
                    <li><Link to="/">Home</Link></li>
                    <li><Link to="/about">About</Link></li>
                    <li><Link to="/services">Services</Link></li>
                    <li><Link to ="/branches">Branches</Link></li>
                    <li><Link to="/loans">Loans</Link></li>
                    <li><Link to="/contact">Contact Us</Link></li>
                    <li><Link to="/news">News</Link></li>
                    <li><Link to="/schemes">Schemes</Link></li>
                </ul>
            </nav>

            <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
                ☰
            </div>

            {menuOpen && (
                <div className="mobile-menu">
                    <ul>
                        <li><Link to="/" onClick={()=>setMenuOpen(false)}>Home</Link></li>
                        <li><Link to="/about" onClick={()=>setMenuOpen(false)}>About</Link></li>
                        <li><Link to ="/services" onClick={()=>setMenuOpen(false)}>Services</Link></li>
                        <li><Link to="/branches" onClick={()=>setMenuOpen(false)}>Branches</Link></li>
                        <li><Link to="/loans" onClick={()=>setMenuOpen(false)}>Loans</Link></li>
                        <li><Link to="/contact" onClick={()=>setMenuOpen(false)}>Contact Us</Link></li>
                        <li><Link to="/news" onClick={()=>setMenuOpen(false)}>News</Link></li>
                        <li><Link to="/schemes" onClick={()=>setMenuOpen(false)}>Schemes</Link></li>

                    </ul>
                </div>
            )}

        </header>
    );
}

export default Header;
